module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_4-27291e75c388d78c763e8e37b70a1ff5.svg";